import { FC, ReactNode } from "react";
import useStyles from "./FormContainer.styles";

interface FormContainerProps {
  children: ReactNode;
}

const FormContainer: FC<FormContainerProps> = ({ children }) => {
  const { classes } = useStyles();

  return <div className={classes.container}>{children}</div>;
};

export default FormContainer;
